(function($, App, Utils){
  'use strict';

  Utils.add('Ajax', {

    useUjs: false,

    Selectors: {
      selectFormSubmit: "select[data-form-submit]",
      buttonSubmitMethod: "button[type=submit][data-form-method], input[type=submit][data-form-method]",
      replaceElement: "[data-replace-element]",
      emptyElement: "[data-empty-element]",
      cleanSelect: "[data-clean-select]",
      removeElement: "[data-remove-element]",
      refreshElement: "[data-refresh-element]",
      appendToElement: "[data-append-to]"
    },

    options: {
      cache: false
    },

    Events: {
      Before: 'ajax:content:loading',
      Success: 'ajax:content:new',
      Error: 'ajax:content:error',
      Completed: 'ajax:content:completed',
    },


    init: function() {
      // Ensure to rebind events when new content comes.
      $.ajaxSetup({
        beforeSend: function() {
          App.Html.addClass('loading');
          Utils.Ajax.trigger(Utils.Ajax.Events.Before);
        },
        success: function(data, ok, xhr) {
          setTimeout(function(){
            Utils.Ajax.trigger(Utils.Ajax.Events.Success, [data, xhr]);
            App.Html.removeClass('loading');
          }, 1);
        },
        error: function(xhr, err, errstr) {
          setTimeout(function(){
            Utils.Ajax.trigger(Utils.Ajax.Events.Error, xhr);
            Utils.Ajax.trigger(Utils.Ajax.Events.Error + ":" + xhr.status, xhr);
            App.Html.removeClass('loading');
          }, 1);
        },
        complete: function() {
          setTimeout(function(){
            Utils.Ajax.trigger(Utils.Ajax.Events.Completed);
            App.Html.removeClass('loading');
          }, 1);

        }
      });

      if ( ! Utils.Ajax.useUjs ) {
        console.warn("ujs has been disabled");
        return true;
      }


      // Utils function for emitting event once element has been removed/replaced
      var origRemove = $.fn.remove;
      $.fn.remove = function() {
        var ev;
        ev = new $.Event("removed");
        $(this).trigger(ev);
        return origRemove.apply(this, arguments);
      };

      var origReplace = $.fn.replaceWith;
      $.fn.replaceWith = function() {
        var ev;
        ev = new $.Event("replaced");
        $(this).trigger("replaced");
        return origReplace.apply(this, arguments);
      };


      var _rAjax = $.rails.ajax;

      $.rails.ajax = function(options) {
        options = $.extend({}, options, Utils.Ajax.options);
        return _rAjax(options);
      };


      App.Document.on("change", Utils.Ajax.Selectors.selectFormSubmit, function(e) {
        var $this = $(this);
        var f = $this.data("form-submit") || $this.closest("form");
        $(f).submit();
        return e.preventDefault();
      });


      App.Document.on("click", Utils.Ajax.Selectors.buttonSubmitMethod, function(e) {
        var form, method;
        form = $(this).closest("form");
        method = $(this).data("form-method");
        !!method && form.attr("method", method);
      });


      App.Document.on("ajax:success", Utils.Ajax.Selectors.replaceElement, function(e, data, status, xhr) {
        return Utils.Ajax.replaceElementSuccess(e, this, data, status, xhr);
      });

      App.Document.on("ajax:error", Utils.Ajax.Selectors.replaceElement, function(e, xhr, status, error) {
        return Utils.Ajax.replaceElementError(e, this, xhr, status, error);
      });

      App.Document.on("ajax:success ajax:error", Utils.Ajax.Selectors.emptyElement, function(e, dataOrXhr, status, xhr) {
        return Utils.Ajax.emptyElementSuccess(e, this, dataOrXhr, status, xhr);
      });

      App.Document.on("ajax:success", Utils.Ajax.Selectors.cleanSelect, function(e, data, status, xhr) {
        return Utils.Ajax.cleanSelectSuccess(e, this, data, status, xhr);
      });

      App.Document.on("ajax:success", Utils.Ajax.Selectors.removeElement, function(e, data, status, xhr) {
        return Utils.Ajax.removeElementSuccess(e, this, data, status, xhr);
      });

      App.Document.on("ajax:success", Utils.Ajax.Selectors.refreshElement, function(e, data, status, xhr) {
        return Utils.Ajax.refreshElementSuccess(e, this, data, status, xhr);
      });

      App.Document.on("ajax:success", Utils.Ajax.Selectors.appendToElement, function(e, data, status, xhr) {
        return Utils.Ajax.appendToElementSuccess(e, this, data, status, xhr);
      });

      App.Document.on("ajax:beforeSend", "[data-remote]", function(e) {
        var block = $(this).data("block-element");
        $(block).attr("disabled", "disabled");
        return true;
      });


    },


    /**
     *  Replace element with given html, in case of success
     *  params:
     *    e:            the jQuery.Event object
     *    target:       HTML element that fired the event
     *    data:         response in string
     *    status:       response status
     *    xhr:          the XHR object
     */
    replaceElementSuccess: function(e, target, data, status, xhr) {
      var replace = $(target).data("replace-element");
      var html = $(data);
      if (html.length > 0) {
        // empty HTML
        $(replace).replaceWith(html);
      } else {
        $(replace).html(data);
      }
      if ($(target).data("use-anchor")) {
        window.location.hash = replace;
      }
      return false;
    },

    /**
     *  Replace element with given html, in case of error
     *  params:
     *    e:            the jQuery.Event object
     *    target:       HTML element that fired the event
     *    xhr:          the XHR object
     *    status:       response status
     *    error:        the Error object
     */
    replaceElementError: function(e, target, xhr, status, error) {
      if (xhr.status === 401 || xhr.status === 403) {
        return false;
      }
      var replace = $(this).data("replace-element");
      var html = $(xhr.responseText);
      if (html.length > 0) {
        $(replace).replaceWith(html);
      } else {
        $(replace).html(html);
      }
      if ( $(this).data("use-anchor") ) {
        return window.location.hash = replace;
      }
    },

    /**
     *  Empty element, in case of success AND in case of error
     *  params:
     *    e:            the jQuery.Event object
     *    target:       HTML element that fired the event
     *    dataOrXhr:    response in string OR the XHR object (in case of orror)
     *    status:       response status
     *    xhr:          the XHR object OR the Error object ( in case of error)
     */
    emptyElementSuccess: function(e, target, dataOrXhr, status, xhr) {
      if (dataOrXhr.status === 401) {
        // in case of error
        return false;
      }
      var empty = $(this).data("empty-element");
      $(empty).empty();
      return false;
    },

    /**
     *  Remove all '<option >' with value, but '<option >' without value, in case of success
     *  params:
     *    e:            the jQuery.Event object
     *    target:       HTML element that fired the event
     *    data:         response in string
     *    status:       response status
     *    xhr:          the XHR object
     */
    cleanSelectSuccess: function(e, target, data, status, xhr) {
      var clean = $(this).data("clean-select");
      $(clean).find("option[value!='']").remove();
      return true;
    },


    /**
     *  Remove element, in case of success
     *  params:
     *    e:            the jQuery.Event object
     *    target:       HTML element that fired the event
     *    data:         response in string
     *    status:       response status
     *    xhr:          the XHR object
     */
    removeElementSuccess: function(e, target, data, status, xhr) {
      var remove = $(target).data("remove-element");
      $(remove).remove();
      return true;
    },

    /**
     *  Trigger click on given element, in case of success
     *  params:
     *    e:            the jQuery.Event object
     *    target:       HTML element that fired the event
     *    data:         response in string
     *    status:       response status
     *    xhr:          the XHR object
     */
    refreshElementSuccess: function(e, target, data, status, xhr) {
      var refresh = $(target).data("refresh-element");
      $(refresh).click();
      return false;
    },


    /**
     *  Create an element and append it to a given element, in case of success
     *  params:
     *    e:            the jQuery.Event object
     *    target:       HTML element that fired the event
     *    data:         response in string
     *    status:       response status
     *    xhr:          the XHR object
     */
    appendToElementSuccess: function(e, target, data, status, xhr) {
      var parentElement = $(target).data("append-to");
      return $(data).appendTo( $(parentElement) );
    }


  });

})(jQuery, window.App, window.App.Utils );
